import React from 'react'
//import { useNavigate } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import {
	CRow,
	CCol,
	CForm,CInputGroup,CFormSelect,CFormInput,CButton,
	//CImage,
	CCard,CCardHeader,CCardFooter,CCardBody,
	CLink,
	CTooltip,
	CSpinner,
} from '@coreui/react';
//import NumberFormat from 'react-number-format';
import { isMobile } from "react-device-detect";
import CIcon from '@coreui/icons-react';
import {
	//MyDialogview,MyDialoglookupapi,
	MyDialogform,
	MyPagination,
	MyPage500,
} from '../components/index'
import * as FileSaver from "file-saver";
import XLSX from "sheetjs-style";
import { UFunc,cBulanPanjang,cBulanPendek } from '../helpers/functions'
//import { Konfirm } from '../helpers/onConfirm';

const pjson 	= require('../../package.json')
const Lapkasir 	= (props) => {
	const {
		setLoading,showToast,prosesExpired,setSessionaktif
	} = props; 

	//--DOM--/
	//const uNavigate 			= useNavigate();
	const uDispatch 			= useDispatch();
	//--END DOM--/

	const uTokenObj				= JSON.parse(localStorage.getItem("token")||"{}");
	const uBahasaObj  			= useSelector(state => state.listBahasa);
	const uActiveroute  		= useSelector(state => state.activeRoute);
	const uEfekapp				= useSelector(state => state.effectApp);
	const uSettinguserObj		= useSelector(state => state.gListUserSetting);
	const uSettingsystemObj		= useSelector(state => state.gSystemsetting);
	const uHTMLstyleTabel		= useSelector(state => state.gHTMLstyleLaporan);
	const [uEfekview,setEfekview]= React.useState(false);

	const uMaxData				= isMobile ? (uSettinguserObj.jml_mobile || 20) : (uSettinguserObj.jml_laporan || 100);

	const uHeaderActionObj  	= useSelector(state => state.gInitHeaderAction);
	const uHandelView 			= uHeaderActionObj.isHeaderView || false;
	const uHandelReset	 		= uHeaderActionObj.isHeaderReset || false;

	const [uHTMLError500,setHTMLError500]	= React.useState();
	const [uDatavieworiArr,setDatavieworiArr]= React.useState([]);
	const [uDataviewArr,setDataviewArr]		= React.useState([]);
	const [uPageActive,setPageActive]		= React.useState(1);
	const [uJmlData,setJmlData] 			= React.useState(0);
	const [uJmlHal,setJmlHal] 				= React.useState(1);
	const [uTabelRowSelect,setTabelRowSelect]= React.useState(-1);
	const [uTimeElapsed,setTimeElapsed]		= React.useState(0);
	const [uTabelIDPilih,setTabelIDPilih]	= React.useState(0);
	const [uDataloadedObj,setDataloadedObj]	= React.useState();
	const [uTitelObj,setTitelObj]			= React.useState({});
	const [uDataidentitasObj,setDataidentitasObj]	= React.useState({});
	const [uDatapaymentArr,setDatapaymentArr]	= React.useState([]);
	const [uSortedObj,setSortedObj]			= React.useState({});

	//---DLGFORM--/
	const [uISDlgformshow,setDlgformshow]	= React.useState(false);
	const [uDlgformObj,setDlgformObj]		= React.useState({});
	//---END DLGFORM--/

	/*//--DLG_LOOKUP--/
	const [uISDlglookupshow,setDlglookupshow]= React.useState(false);
	const [uDlglookupObj,setDlglookupObj]	= React.useState({});
	//--END DLG_LOOKUP--/

	//--DLG_VIEW--/
	const [uISDlgviewshow,setDlgviewshow]	= React.useState(false);
	const [uDlgviewObj,setDlgviewObj]		= React.useState({});
	//--END DLG_VIEW--*/

	//--DOM_ELEMENTS--/
	const uElJmldata	= document.getElementById("idjmldata");
	const uFrameExport 	= document.getElementById("ifmcontentstoprint");
	const fileType 		= "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
	const fileExtension = ".xlsx";
	//--END DOM_ELEMENTS--/

	//---HANDLE--/
	/*const hdlKDownCustomerlookup = (_EV) => {//--TIDAK_DIPAKAI--/
		uDlgformObj.customer_id 	= undefined;

		if(_EV.keyCode !== 13) { setEfekview(!uEfekview); return }
		if((uDlgformObj.customer_caption||"").trim() === "") 
			{ setEfekview(!uEfekview); return }

		_EV.preventDefault(); _EV.stopPropagation();

		uDlglookupObj.is_triggered = true; setEfekview(!uEfekview);
		hdlKlikCustomerlookup();
	}
	const hdlKlikCustomerlookup = () => {//--TIDAK_DIPAKAI--/
		uDlglookupObj.inputvalue= uDlgformObj.customer_caption||"";
		uDlglookupObj.header 	= (uBahasaObj.word_lookup||"word_lookup")+": "+(uBahasaObj.word_customer||"word_customer");
		setDlglookupshow(true);
	}
	const hdlKlikDlglookuppilih = (_SELECTEDSTR) => {//--TIDAK_DIPAKAI--/
		_SELECTEDSTR = _SELECTEDSTR||"{}";
		//if(_SELECTEDSTR==="" || _SELECTEDSTR === "{}") return;
		const vLookupObj	= JSON.parse(_SELECTEDSTR);
		if(vLookupObj==={}) return;

		uDlgformObj.customer_id 		= parseInt(vLookupObj.id || "0");
		uDlgformObj.customer_caption	= vLookupObj.caption || "";

		setDlglookupshow(false);

		let vTimeout = setTimeout(function(){
			clearTimeout(vTimeout);
			const vElsFocus	= document.getElementById("btnDialogSimpan");
			vElsFocus && vElsFocus.focus();
		},550);
	}//-*/
	const hdlKlikDlgformsimpan = () => {
		let vElfocus	= document.getElementById("inpjenis");
		if(uDlgformObj.jenis!=="REKAPHARIAN" 
			&& uDlgformObj.jenis!=="HARIAN" 
			&& uDlgformObj.jenis!=="BULANAN") {
			vElfocus && vElfocus.focus();
			showToast("Jenis Laporan Tidak Valid !"); return
		} 

		if(uDlgformObj.jenis === "BULANAN") {
			vElfocus	= document.getElementById("inpbulanid");
			if((parseInt(uDlgformObj.bln_id)||0) <= 0) {
				vElfocus && vElfocus.focus();
				showToast("Periode Bulan Tidak Valid !"); return
			} 
			vElfocus	= document.getElementById("inptahun");
			if((parseInt(uDlgformObj.tahun)||0) <= 0) {
				vElfocus && vElfocus.focus();
				showToast("Periode Tahun Tidak Valid !"); return
			} 
			vElfocus	= document.getElementById("inpbulanid");
			const vTanggalpilihDT = UFunc.toDate(uDlgformObj.tahun+"-"+UFunc.leadZero(uDlgformObj.bln_id)+"-01");
			if(UFunc.DateIsBeyond(vTanggalpilihDT)) {
				vElfocus && vElfocus.focus();
				showToast("Periode Bulan/Tahun Tidak Valid !"); return
			}
		} else {
			vElfocus	= document.getElementById("inptanggal");
			if(uDlgformObj.tanggal === "") {
				vElfocus && vElfocus.focus();
				showToast("Periode Tanggal Tidak Valid !"); return
			}

			const vTanggalDT = UFunc.toDate(uDlgformObj.tanggal);
			if(UFunc.DateIsBeyond(vTanggalDT)) {
				vElfocus && vElfocus.focus();
				showToast("Periode Tanggal Belum Terjadi !"); return
			} 
		}
		/*vElfocus	= document.getElementById("inpcustomercaption");
		if((uDlgformObj.customer_caption||"").trim() !== "")
			if((parseInt(uDlgformObj.customer_id)||0) <= 0) {
				vElfocus && vElfocus.focus();
				showToast("Nama Customer TIDAK Dipilih Dengan Benar..<br/>Mohon Diperbaiki !"); return
			}//-*/

		apiLoadview();
	}
	/*const hdlKlikDetilitem = (_IDTABEL) => {//--TIDAK_DIPAKAI--/
		_IDTABEL = parseInt(_IDTABEL)||0; if(_IDTABEL <= 0) return;

		setTabelIDPilih(_IDTABEL);
		const vRowIdx	= UFunc.getTabelRowIndeks("idtabeldata","idtr"+_IDTABEL);
		setTabelRowSelect(vRowIdx);

		const vArridx	= UFunc.getObjectIndeks(uDataviewArr,_IDTABEL);
		if((uDataviewArr[vArridx].item_arr||[]).length > 0) {
			uDlgviewObj.header = "Detil Item: "+uDataviewArr[vArridx].no_nota;
			setDlgviewshow(true);
			return;
		}

		apiLoaditem(_IDTABEL);
	}//-*/
	const hdlKlikCetak = () => {
		if(uJmlData <= 0) return;

		let vContent 	= contentHTMLcetak();
		let pri 		= uFrameExport.contentWindow;
		pri.document.open();
		pri.document.write(vContent);
		pri.document.close();
		pri.focus();
		pri.print();
	}
	const hdlKlikExcel = () => {
		if(uJmlData <= 0) return;

		contentExcel();
	}
	//---END HANDLE--/

	//---PROSES--/
	const initJmldata = () => {
		uElJmldata && 
			(uElJmldata.innerHTML = UFunc.formatAngka(uJmlData));
	}
	//---END PROSES--/

	//---CONTENT--/
	const contentMain = () => {
		if(uHTMLError500) return "";

		if(uJmlData <= 0) return (
		<div className="text-center my-2 my-lg-5">
			<big className="fst-italic text-primary">
			{uBahasaObj.pesan_dataempty||"Data dengan Filter yang Dipilih Tidak Ditemukan.."}
			</big>
		</div>
		)//>

		if(uDataloadedObj.jenis === "REKAPHARIAN") {
			return contentRekap();
		}

		return contentNonrekap();
	}
	const contentRekap = () => {
		if(uDataloadedObj.jenis !== "REKAPHARIAN") return "";
		
		const vColspan		= 3;
		const vDataviewArr	= uDataviewArr;

		return (
		<div className="mx-lg-5 px-lg-5">
			<table className="table table-borderless table-striped table-hover" id="idtabeldata">
			<thead>
			<tr className="text-center align-top classfontsmaller">
			<th width={35} className="border">No</th>
			<th className="text-start border">Metode Pembayaran</th>
			<th className="border" style={{maxWidth:125,minWidth:120,width:"30%"}}>
				<div className="d-flex justify-content-center">
				<div>
					{uBahasaObj.caption_ntransaksi||"N.Transaksi"}
					<small className="d-block">(Rp)</small>
				</div>
				<CLink onClick={()=>{
						if((uSortedObj.field||"")!=="nilai_mutasi") 
							setSortedObj({ field: "nilai_mutasi",mode:"ASC" })
						else {
							if(uSortedObj.mode===undefined) uSortedObj.mode = "ASC";
							else if(uSortedObj.mode==="ASC") uSortedObj.mode = "DESC";
							else setSortedObj({});
						}
						setEfekview(!uEfekview);
					}}
					className={"ms-1 classcursorpointer "+((uSortedObj.field||"")==="nilai_mutasi"?"text-danger":"text-primary")}>
					<CIcon icon={((uSortedObj.mode||"")==="DESC"?"cilArrowBottom":"cilArrowTop")} className="align-middle" height={20}/>
				</CLink>
				</div>
			</th>
			</tr>
			<tr className="d-none"><th colSpan={vColspan}>{JSON.stringify(uDataloadedObj)}</th></tr>
			</thead>

			<tbody>
			{vDataviewArr.map((vItems,vKeys)=>{
				const {
					payment_caption,payment_id,nilai_mutasi,
					id
				} = vItems;

				return (
				<tr className="align-top" key={vKeys}>
				<td align="right" className="px-1">{vKeys+1}.</td>
				<td align="left" className="px-1">{payment_caption || "Undf Payment"}</td>
				<td align="right" className="px-1 fw-bolder">{UFunc.formatAngka(nilai_mutasi)}</td>
				</tr>
				)
			})}
			</tbody>

			<tfoot className="border-top border-top-primary">
			<tr className="fw-bolder text-white bg-dark">
			<td colSpan={vColspan-1} className="text-start text-md-center">JUMLAH</td>
			<td className="text-end">{UFunc.formatAngka(uDataloadedObj.sum_nilai_mutasi)}</td>
			</tr>
			</tfoot>
			</table>
		</div>
		)//->
	}
	const contentNonrekap = () => {
		if(uDataloadedObj.jenis !== "HARIAN" && uDataloadedObj.jenis !== "BULANAN") return "XXX";

		const vMin			= (uPageActive-1)*uMaxData;
		const vMax			= (vMin+uMaxData);
		let vNumber			= vMin;

		const vColspan		= 7;
		const vDataviewArr	= uDataviewArr.slice(vMin,(vMax));

		const vStylekolfixed	= {
			position: "sticky",
			left: 0,
			backgroundColor:"#f0f0f0",
			zIndex: 1,
		}

		return (
		<div style={{overflowX: "auto"}}>
			<table style={{minWidth:1000,width:"100%"}} 
				className="table table-borderless table-striped table-hover" id="idtabeldata">
			<thead>
			<tr className="text-center align-top classfontsmaller">
			<th width={45} className="border" style={vStylekolfixed}>No</th>
			<th width={130} className="text-start border" style={{...vStylekolfixed,left:45}}>Tanggal</th>
			<th width={70} className="text-start border">{uBahasaObj.word_nota||"Nota"}</th>

			<th className="text-start border">{uBahasaObj.word_keterangan||"Keterangan"}</th>
			<th width={100} className="border">{uBahasaObj.caption_metodebayar||"Metode Bayar"}</th>
			<th width={70} className="border">{uBahasaObj.word_status||"Status"}</th>
			
			<th width={150} className="border">
				{uBahasaObj.caption_ntransaksi||"N.Transaksi"} (Rp)
			</th>
			</tr>
			<tr className="d-none"><th colSpan={vColspan}>{JSON.stringify(uDataloadedObj)}</th></tr>
			</thead>

			<tbody>
			{vDataviewArr.map((vItems,vKeys) => {
				const {
					id,tgl_transaksi,no_nota,keterangan,status_mutasi,nilai_mutasi,nilai_saldo,
					payment_caption,is_processing
				} = vItems;

				vNumber++;

				return (
				<tr id={"idtr"+id} className={"align-top"+(uTabelRowSelect===vKeys?" classrowselect":"")} key={vKeys}>
				<td className="px-1 text-end" style={vStylekolfixed}>{vNumber}.</td>
				<td className="px-1 text-start" style={{...vStylekolfixed,left:45}}>
					<small>{UFunc.WaktuAngka(tgl_transaksi)}</small>
				</td>

				<td className="px-1 text-start">
					<small className="fw-bolder">{(no_nota||"-")}</small>
				</td>

				<td className="text-start px-1 fst-italic classfontsmaller">{keterangan||"-"}</td>
				<td className="text-center px-1">{payment_caption||"-"}</td>
				<td className="text-center px-1">
					{(status_mutasi||"-")==="MASUK" ? (
						<b>{status_mutasi}</b>
					) : (
						<span className="text-danger">{status_mutasi}</span>
					)}
				</td>
				
				<td className="text-end px-1">
					{(parseFloat(nilai_mutasi)||0) > 0 ? (
					<span className="text-success">{UFunc.formatAngka(nilai_mutasi)}</span>
					) : (
					<span className="text-danger">-({UFunc.formatAngka(Math.abs(parseFloat(nilai_mutasi)))})</span>
					)}
				</td>
				</tr>
				)
			})}
			</tbody>

			<tfoot className="border-top border-top-primary">
			<tr className="fw-bolder text-white bg-dark">
			<td colSpan={vColspan-1} className="text-start text-md-center">JUMLAH</td>
			<td className="text-end">{UFunc.formatAngka(uDataloadedObj.sum_nilai_mutasi)}</td>
			</tr>
			</tfoot>
			</table>
		</div>
		)//>
	}
	const contentDlgform = () => {
		if(!uISDlgformshow) return (<></>)//>

		const vJmlTahunlaporan	= parseInt(uSettingsystemObj.jml_tahun_laporan)||5;

		return (
		<CForm>
		<CRow className="my-2">
		<CCol xs="3" md="4">Jenis Periode</CCol>
		<CCol>
			<CFormSelect size="sm"
				value={uDlgformObj.jenis}
				onChange={(e)=>{uDlgformObj.jenis=e.target.value; setEfekview(!uEfekview)}}
				id="inpjenis">
				<option value="REKAPHARIAN">REKAP HARIAN</option>
				<option value="HARIAN">HARIAN</option>
				<option value="BULANAN">BULANAN</option>
			})}
			</CFormSelect>
		</CCol>
		</CRow>

		<CRow className="my-2">
		<CCol xs="3" md="4">Periode</CCol>
		<CCol>
			{uDlgformObj.jenis === "BULANAN" ? (
			<CInputGroup size="sm">
			<CFormSelect size="sm"
				className="w-auto"
				value={uDlgformObj.bln_id}
				onChange={(e)=>{uDlgformObj.bln_id=e.target.value; setEfekview(!uEfekview)}}
				id="inpbulanid">
			{cBulanPanjang.map((vItems,vKeys)=>{
				return (
				<option value={vKeys+1} key={vKeys}>{vItems.toUpperCase()}</option>
				)
			})}
			</CFormSelect>
			
			<span className="me-1"/>

			<CFormSelect size="sm"
				value={uDlgformObj.tahun}
				onChange={(e)=>{uDlgformObj.tahun=e.target.value; setEfekview(!uEfekview)}}
				id="inptahun">
				{(() => {
					let vTmpArr 	= [];
					const vTahunnow	= (new Date()).getFullYear();
					for(var vIdx=0;vIdx < vJmlTahunlaporan;vIdx++) {
						vTmpArr.push(
						<option value={(vTahunnow - vIdx)} key={vIdx}>{(vTahunnow - vIdx)}</option>
						)
					}
					return vTmpArr;
				})()}
			</CFormSelect>
			</CInputGroup>
			) : (
			<CFormInput type="date" size="sm"
				onKeyDown={(e)=>{
					if(e.keyCode !== 13) return;

					const vElnext = document.getElementById("inppaymentid");
					//console.log("vElnext => "+vElnext);
					if(vElnext.disabled === true) {
						UFunc.hdlKeyDownInput(e,"btnDialogSimpan");
						return;
					}
				}}
				value={uDlgformObj.tanggal}
				onChange={(e)=>{uDlgformObj.tanggal=e.target.value; setEfekview(!uEfekview)}}
				id="inptanggal"/>
			)}
		</CCol>
		</CRow>

		<div className="my-3 classborderbottom"/>

		<CRow className="my-2">
		<CCol xs="3" md="4">Payment</CCol>
		<CCol>
			<CFormSelect size="sm"
				value={uDlgformObj.payment_id||0}
				onChange={(e)=>{uDlgformObj.payment_id=e.target.value; setEfekview(!uEfekview)}}
				onKeyDown={(e)=>UFunc.hdlKeyDownInput(e,"btnDialogSimpan")}
				id="inppaymentid">
			<option value="0">--SEMUA METODE PEMBAYARAN--</option>
			{uDatapaymentArr.map((vItems,vKeys)=>{
				return (
					<option key={vKeys} value={vItems.id}>{(vItems.caption||"").toUpperCase()}</option>
				)
			})}
			</CFormSelect>
		</CCol>
		</CRow>
		</CForm>
		)//>
	}
	/*
	const contentDlgview = () => {//--TIDAK_DIPAKAI--/
		if(!uISDlgviewshow) return (<></>)//>

		const vArridx	= UFunc.getObjectIndeks(uDataviewArr,uTabelIDPilih);
		if(vArridx < 0) return (<></>)//>

		return (
		<small>
		<CRow className="align-items-stretch">
		<CCol lg="6">
			<CCard className="h-100">
			<CCardHeader className="py-0 pt-1 classfontsmaller">Data Nota</CCardHeader>
			<CCardBody>
				<div className="d-flex justify-content-between">
					<div>Tgl Transaksi</div>
					<b>{UFunc.TglAngka(uDataviewArr[vArridx].tgl_pendapatan)}</b>
				</div>

				<div className="d-flex justify-content-between">
					<div>No.Nota</div>
					<div>{(uDataviewArr[vArridx].no_nota)}</div>
				</div>

				<div className="d-flex justify-content-between">
					<div>Customer</div>
					<b>{(uDataviewArr[vArridx].customer_caption||"-")}</b>
				</div>
			</CCardBody>
			</CCard>
		</CCol>

		<CCol lg="6" className="mt-3 mt-lg-0">
			<CCard className="h-100">
			<CCardHeader className="py-0 pt-1 classfontsmaller">Summary Transaksi</CCardHeader>
			<CCardBody>
				<div className="d-flex justify-content-between">
					<div>Jumlah Bruto (Rp)</div>
					<b>{UFunc.formatAngka(uDataviewArr[vArridx].nilai_bruto)}</b>
				</div>
				<div className="d-flex justify-content-between">
					<div>Diskon (Rp)</div>
					<b className="text-danger">{UFunc.formatAngka(uDataviewArr[vArridx].diskon)}</b>
				</div>
				<div className="d-flex justify-content-between">
					<div>Total (Rp)</div>
					<b className="text-success">{UFunc.formatAngka(uDataviewArr[vArridx].nilai_netto)}</b>
				</div>
			</CCardBody>
			</CCard>
		</CCol>
		</CRow>

		<CRow className="mt-3">
		<CCol>
			<CCard>
			<CCardHeader className="py-0 pt-1 classfontsmaller">Data Item</CCardHeader>
			<CCardBody className="px-0">
			<table width="100%" className="table table-borderless table-striped table-hover" 
				id="idtabelitem">
			<thead className="align-top classfontsmaller text-center">
			<tr>
				<th width="5%">No</th>
				<th className="text-start">Item Transaksi</th>
				<th width="25%">Nilai (Rp)</th>
			</tr>
			</thead>
			
			<tbody>
			{(uDataviewArr[vArridx].item_arr||[]).map((vItems,vKeys)=>{
				const {
					harga_satuan,qty,item_satuan,item_caption,
					pasien_caption,item_idx
				} = vItems;

				return (
				<tr className="align-top" key={vKeys}>
				<td align="right">{vKeys+1}.</td>

				<td>
					<div>
						{(pasien_caption||"")!==""
							? (<><span className="text-primary">{pasien_caption}</span> &middot; </>)
							: ("")
						}
						<small>{item_caption}</small>
					</div>

					<small className="fst-italic d-block ms-2">
						&#8702; <b>{qty}</b> {item_satuan} x Rp<b>{UFunc.formatAngka(harga_satuan)}</b>
					</small>
				</td>

				<td align="right">
					<b className="text-success">{UFunc.formatAngka(parseInt(qty||"1") * parseFloat(harga_satuan))}</b>
				</td>
				</tr>
				)
			})}
			</tbody>
			</table>
			</CCardBody>
			</CCard>
		</CCol>
		</CRow>
		</small>
		)//>
	}//-*/
	const contentHTMLcetak = () => {
		if(uDataloadedObj.jenis === "REKAPHARIAN") return contentCetakrekap();

		return contentCetaknonrekap();
	}
	const contentCetakrekap = () => {
		let vHTMLs	= uHTMLstyleTabel;

		const vColspan 		= 3;
		const vDataviewArr	= uDataviewArr;

		vHTMLs	+= UFunc.RenderTabel(uDataidentitasObj,vColspan);
		
		const vJudullaporan = uBahasaObj["menus_"+(uActiveroute||"").toLowerCase()]+" (REKAP)";
		const vJudulsub		= `
			<div>Periode `+
			` <b>`+((uTitelObj||{}).periode||"")+`</b></div>
			<div>`+((uTitelObj||{}).subtitel||"")+`</div>
		`;

		const vTabelheader	= `
			<tr>
			<th width="5%">No</th>
			<th align="left">Metode Payment</th>
			<th width="20%">N.Transaksi (Rp)</th>
			</tr>
		`;
		let vTabelbody	= "";
		let vNumber		= 0;
		vTabelbody 		+= vDataviewArr.map((vItems,vKeys) => {
			const {
				payment_caption,payment_id,nilai_mutasi,
				id
			} = vItems;

			return (`
			<tr valign="top" key=`+vKeys+`>
				<td align="right">`+(vKeys+1)+`.</td>
				<td align="left">`+(payment_caption || "Undf Payment")+`</td>
				<td align="right"><b>`+UFunc.formatAngka(nilai_mutasi)+`</b></td>
			</tr>
			`)
		}).join(``);

		const vTabelfooter 	= `
			<tr valign="top" key={vKeys}>
				<td align="center" colspan="2">JUMLAH</td>
				<td align="right"><b>`+UFunc.formatAngka(uDataloadedObj.sum_nilai_mutasi)+`</b></td>
			</tr>
		`;

		vHTMLs 		= vHTMLs.replace(/_TITELSUB_/g,vJudulsub);
		vHTMLs 		= vHTMLs.replace(/_JUDULLAPORAN_/g,vJudullaporan);
		vHTMLs 		= vHTMLs.replace(/_TABELHEADER_/g,vTabelheader);
		vHTMLs 		= vHTMLs.replace(/_TABELBODY_/g,vTabelbody);
		vHTMLs 		= vHTMLs.replace(/_TABELFOOTER_/g,vTabelfooter);

		return vHTMLs;
	}
	const contentCetaknonrekap = () => {
		let vHTMLs	= uHTMLstyleTabel;

		//console.log("(Lapkasir - contentHTMLcetak) uDataidentitasObj => "+(uDataidentitasObj));

		const vColspan 		= 7;
		const vDataviewArr	= uDataviewArr;

		vHTMLs	+= UFunc.RenderTabel(uDataidentitasObj,vColspan);
		
		const vJudullaporan = uBahasaObj["menus_"+(uActiveroute||"").toLowerCase()];
		const vJudulsub		= `
			<div>Periode `+
			(uDataloadedObj.jenis==="BULANAN" ? "Bulan" : "Tanggal")+
			` <b>`+((uTitelObj||{}).periode||"")+`</b></div>
			<div>`+((uTitelObj||{}).subtitel||"")+`</div>
		`;

		const vTabelheader	= `
			<tr>
			<th width="6%">No</th>
			<th width="15%" align="left">`+(uBahasaObj.word_tanggal||"Tanggal")+`</th>
			<th width="11%" align="left">No.Nota</th>
			<th align="left">Keterangan</th>
			<th width="11%">Metode</th>
			<th width="7%">Status</th>
			<th width="11%">N.Transaksi (Rp)</th>
			</tr>
		`;
		
		let vTabelbody	= "";
		let vNumber		= 0;
		vTabelbody 		+= vDataviewArr.map((vItems,vKeys) => {
			const {
				id,tgl_transaksi,no_nota,keterangan,status_mutasi,nilai_mutasi,nilai_saldo,
				payment_caption
			} = vItems;

			vNumber++;

			return (`
				<tr valign="top" key=`+vKeys+` style="font-size:smaller;">
				<td align="right">`+vNumber+`.</td>
				<td align="left">`+UFunc.WaktuAngka(tgl_transaksi)+`</td>
				<td align="left">
					<small style="font-weight:bolder">`+(no_nota||"-")+`</small>
				</td>
				<td align="left"><i>`+(keterangan||"-")+`</i></td>
				<td align="center"><small>`+(payment_caption||"-")+`</small></td>
				<td align="center"><small>`+(status_mutasi||"-")+`</small></td>
				<td align="right"><b>`+UFunc.formatAngka(nilai_mutasi)+`</b></td>
				</tr>
			`);
		}).join("");
		

		const vTabelfooter 	= `
			<td colspan="`+(vColspan-1)+`">JUMLAH</td>
			<td align="right">`+UFunc.formatAngka(uDataloadedObj.sum_nilai_mutasi)+`</td>
		`;

		vHTMLs 		= vHTMLs.replace(/_TITELSUB_/g,vJudulsub);
		vHTMLs 		= vHTMLs.replace(/_JUDULLAPORAN_/g,vJudullaporan);
		vHTMLs 		= vHTMLs.replace(/_TABELHEADER_/g,vTabelheader);
		vHTMLs 		= vHTMLs.replace(/_TABELBODY_/g,vTabelbody);
		vHTMLs 		= vHTMLs.replace(/_TABELFOOTER_/g,vTabelfooter);

		return vHTMLs;
	}
	const contentExcel = () => {
		if(uDataloadedObj.jenis === "REKAPHARIAN") {
			contentExcelrekap(); return;
		}

		contentExcelnonrekap();
	}
	const contentExcelrekap = () => {
		const vTanggalDT= UFunc.toDate(uDataloadedObj.tanggal);

		const vBulanID	= vTanggalDT.getMonth()+1;
		const vTahun	= vTanggalDT.getFullYear();

		const vColspan 		= 3;
		let vDatasetsArr 	= [];
		let vRowcount		= 0;
		let vColposwidth	= 200;

		let vTmpObj	= {
			no : "",
			payment_caption: "",
			nilai_mutasi: "",
		}
		vDatasetsArr.push(vTmpObj);

		vRowcount++;
		uDataviewArr.forEach((vItems,vKeys)=>{
			const {
				payment_caption,payment_id,nilai_mutasi,
				id
			} = vItems;

			vColposwidth = (payment_caption||"").length > vColposwidth 
				? (payment_caption||"").length : vColposwidth; 

			vTmpObj	= {
				no : {v:vKeys+1,t:"n"},
				payment_caption: (payment_caption||"-"),
				nilai_mutasi: { v:parseFloat(nilai_mutasi || "0"), t:"n", s:{numFmt: "#,##0"} },
			}

			vDatasetsArr.push(vTmpObj);
			vRowcount++;
		});

		//--SUM_NILAI--/
		vTmpObj	= {
			no : {v: "JUMLAH",t:"s",s:{alignment:{horizontal:"center"},font:{bold:true} }},
			payment_caption: "",
			nilai_mutasi: { v:parseFloat(uDataloadedObj.sum_nilai_mutasi)||0, t:"n", s:{numFmt: "#,##0",font:{bold:true} } },
		};
		vDatasetsArr.push(vTmpObj);
		vRowcount++;
		//--END SUM_NILAI--/

		//if(vColposwidth > 300) vColposwidth = 300;
		const wsrows	= [{hpt:47}]
		const wscols	= [
			{wpx:40},
			{wpx:vColposwidth},
			{wpx:120},
		];
		
		const wsmerge	= [
			{s:{r:0,c:0},e:{r:0,c:vColspan - 1}},
			{s:{r:vRowcount,c:0},e:{r:vRowcount,c:vColspan - 2}}
		]

		const vTanggalnowDT	= new Date()
		const vNamafile 	= 
			vTanggalnowDT.getFullYear()+
			UFunc.leadZero(vTanggalnowDT.getMonth()+1)+
			UFunc.leadZero(vTanggalnowDT.getDate())+"_Lapkasirrekap_"+
				(uDataloadedObj.tanggal||"").replaceAll("-","")+
		"";
		const vSheetlabel = (cBulanPendek[vBulanID-1])+vTahun;

		const ws 		= XLSX.utils.json_to_sheet(vDatasetsArr);
		//--CUSTOM_HEADER--/
		const vJudullaporan = uBahasaObj["menus_"+(uActiveroute||"").toLowerCase()]+
			"\r\nPeriode "+(uTitelObj||{}).periode+
			"\r\n"+(uTitelObj||{}).subtitel+
		"";
		const vHeaderArr = [
			{v:"No",s:{alignment:{horizontal:"center"},font:{bold:true}}}, 
			{v:"Metode Pembayaran",s:{alignment:{horizontal:"left"},font:{bold:true}}}, 
			{v:"Status",s:{alignment:{horizontal:"center"},font:{bold:true}}}, 
		];
		//--END CUSTOM_HEADER--/

		XLSX.utils.sheet_add_aoa(ws, [[{v:vJudullaporan,t:"s",s:{
			alignment:{horizontal:"center",wrapText: true},
			font:{bold:true} 
		}}]], { origin: "A1" });
		XLSX.utils.sheet_add_aoa(ws, [vHeaderArr], { origin: "A2" });
		//--END CUSTOM_HEADER--*/
		ws['!rows'] 	= wsrows;
		ws['!cols'] 	= wscols;
		ws["!merges"] 	= wsmerge;

		const wb 		= { Sheets: { [vSheetlabel]: ws }, SheetNames: [vSheetlabel] };
		const excelBuffer = XLSX.write(wb, { bookType: "xlsx", bookSST: true, type: "array" });
		const data 		= new Blob([excelBuffer], { type: fileType });
		FileSaver.saveAs(data, vNamafile + fileExtension);
	}
	const contentExcelnonrekap = () => {
		const vBulanID	= parseInt((uDataloadedObj||{}).bln_id)||"0";
		const vTahun	= parseInt((uDataloadedObj||{}).tahun)||"0";

		const vColspan 		= 7;
		let vDatasetsArr 	= [];
		let vRowcount		= 0;
		let vColposwidth	= 200;

		let vTmpObj	= {
			no : "",
			tgl_transaksi: "",
			no_nota: "",
			keterangan: "",
			payment_caption: "",
			status_mutasi: "",
			nilai_mutasi: "",
		}
		vDatasetsArr.push(vTmpObj);

		vRowcount++;
		uDataviewArr.forEach((vItems,vKeys)=>{
			const {
				id,tgl_transaksi,no_nota,keterangan,status_mutasi,nilai_mutasi,nilai_saldo,
				payment_caption,
			} = vItems;

			vColposwidth = (keterangan||"").length > vColposwidth 
				? (keterangan||"").length : vColposwidth; 

			vTmpObj	= {
				no : {v:vKeys+1,t:"n"},
				tgl_transaksi: { v:UFunc.toDatetime(tgl_transaksi), t:"d",z:"dd/mm/yyyy hh:mm",s:{alignment:{horizontal:"left"}} },
				no_nota: (no_nota||"-"),
				keterangan: (keterangan||"-"),
				payment_caption: (payment_caption||"-"),
				status_mutasi: (status_mutasi||"-"),
				nilai_mutasi: { v:parseFloat(nilai_mutasi || "0"), t:"n", s:{numFmt: "#,##0"} },
			}

			vDatasetsArr.push(vTmpObj);
			vRowcount++;
		});

		//--SUM_NILAI--/
		vTmpObj	= {
			no : {v: "JUMLAH",t:"s",s:{alignment:{horizontal:"center"},font:{bold:true} }},
			tgl_transaksi: "",
			no_nota: "",
			keterangan: "",
			payment_caption: "",
			status_mutasi: "",
			nilai_mutasi: { v:parseFloat(uDataloadedObj.sum_nilai_mutasi)||0, t:"n", s:{numFmt: "#,##0",font:{bold:true} } },
		};
		vDatasetsArr.push(vTmpObj);
		vRowcount++;
		//--END SUM_NILAI--/

		//if(vColposwidth > 300) vColposwidth = 300;
		const wsrows	= [{hpt:47}]
		const wscols	= [
			{wpx:40},
			{wpx:120},
			{wpx:75},
			{wpx:vColposwidth},
			{wpx:100},
			{wpx:85},
			{wpx:85},
		];
		
		const wsmerge	= [
			{s:{r:0,c:0},e:{r:0,c:vColspan - 1}},
			{s:{r:vRowcount,c:0},e:{r:vRowcount,c:vColspan - 2}}
		]

		const vTanggalnowDT	= new Date()
		const vNamafile = 
			vTanggalnowDT.getFullYear()+
			UFunc.leadZero(vTanggalnowDT.getMonth()+1)+
			UFunc.leadZero(vTanggalnowDT.getDate())+"_Lapkasir_"+
			(uDataloadedObj.jenis==="BULANAN"
				? (cBulanPendek[vBulanID-1]).toUpperCase()+"_"+vTahun+
				""
				: (uDataloadedObj.tanggal||"").replace("-","")+
				"")+
		"";
		const vSheetlabel = (cBulanPendek[vBulanID-1])+vTahun;

		const ws 		= XLSX.utils.json_to_sheet(vDatasetsArr);
		//--CUSTOM_HEADER--/
		const vJudullaporan = uBahasaObj["menus_"+(uActiveroute||"").toLowerCase()]+
			"\r\nPeriode "+(uTitelObj||{}).periode+
			"\r\n"+(uTitelObj||{}).subtitel+
		"";
		const vHeaderArr = [
			{v:"No",s:{alignment:{horizontal:"center"},font:{bold:true}}}, 
			{v:"Tanggal",s:{alignment:{horizontal:"left"},font:{bold:true}}}, 
			{v:"No.Nota",s:{alignment:{horizontal:"left"},font:{bold:true}}}, 
			{v:"Customer",s:{alignment:{horizontal:"left"},font:{bold:true}}}, 
			{v:"Metode Pembayaran",s:{alignment:{horizontal:"left"},font:{bold:true}}}, 
			{v:"Status",s:{alignment:{horizontal:"left"},font:{bold:true}}}, 
			{v:"N.Transaksi (Rp)",s:{alignment:{horizontal:"center"},font:{bold:true}}}, 
		];
		if(uDataloadedObj.jenis!=="BULANAN") vHeaderArr.splice(1,1);

		XLSX.utils.sheet_add_aoa(ws, [[{v:vJudullaporan,t:"s",s:{
			alignment:{horizontal:"center",wrapText: true},
			font:{bold:true} 
		}}]], { origin: "A1" });
		XLSX.utils.sheet_add_aoa(ws, [vHeaderArr], { origin: "A2" });
		//--END CUSTOM_HEADER--*/
		ws['!rows'] 	= wsrows;
		ws['!cols'] 	= wscols;
		ws["!merges"] 	= wsmerge;

		const wb 		= { Sheets: { [vSheetlabel]: ws }, SheetNames: [vSheetlabel] };
		const excelBuffer = XLSX.write(wb, { bookType: "xlsx", bookSST: true, type: "array" });
		const data 		= new Blob([excelBuffer], { type: fileType });
		FileSaver.saveAs(data, vNamafile + fileExtension);
	}
	//---END CONTENT--/

	//---API--/
	const apiLoadinit = () => {
		setHTMLError500();
		setDatapaymentArr([]);
		setDataloadedObj();
		setLoading(true);

		/*//--TESTING_FRONTEND--/
		let vTimeout = setTimeout(()=>{
			clearTimeout(vTimeout);
		},2500); return;
		//--END TESTING_FRONTEND--*/

		const vDATAS	= JSON.stringify({
			send_tokenauth : uTokenObj.userinit
		});
		const vURLs	= pjson.homepage+"api/api_lapkasir/ld_init";

		fetch(vURLs,{
			headers: { Accept: "application/json", "Content-Type": "application/json" },
			method: "POST",
			mode: "cors",
			cache: "default",
			body: vDATAS,
		}).then((response)=> { if (response.status === 200) { setSessionaktif(false); return response.json(); } })
		.then((output_string) => {
			setSessionaktif(true)
			setLoading(false);
			if(output_string.tampil) {
				//console.log("(Lapkasir-apiLoadinit) output_string.databiaya : "+(output_string.databiaya));
				setDataidentitasObj(JSON.parse(output_string.dataidentitas || "{}"));
				setDatapaymentArr(JSON.parse(output_string.datapayment || "[]"));
			} else if(output_string.info) {
				setHTMLError500(output_string.info);
			} else if(output_string.errors) {
				console.log("(Lapkasir-apiLoadinit) output_string.errors : "+output_string.errors);
				const vMsg 	= (pjson.mydefault.environment==="development")
					? output_string.errors : pjson.mydefault.msgFetchError;
				setHTMLError500("<font color='red'>"+vMsg+"</font>");
			} else if(output_string.expired) {
				setLoading(true); prosesExpired();
			}
		})
		.catch((error) =>{
			setLoading(false);
			console.log("(Lapkasir-apiLoadinit) catch-error: "+error);
			setHTMLError500(pjson.mydefault.msg500str.join(" "));
		});
	}
	const apiLoadview = () => {
		const vElsimpan	= document.getElementById("btnDialogSimpan");
		setDataloadedObj();
		setDatavieworiArr([]);
		setPageActive(1);
		setTabelIDPilih(0);
		setTabelRowSelect(-1);

		vElsimpan && (vElsimpan.disabled = true);
		setLoading(true);

		/*//--TESTING_FRONTEND--/
		let vTimeout = setTimeout(()=>{
			clearTimeout(vTimeout);
		},2500); return;
		//--END TESTING_FRONTEND--*/

		const vDATAS	= JSON.stringify({
			send_parjson: JSON.stringify(uDlgformObj),
			send_tokenauth : uTokenObj.userinit
		});
		const vURLs	= pjson.homepage+"api/api_lapkasir/ld_view";

		setTimeElapsed(0);
		const vTimeBegin = new Date();
		fetch(vURLs,{
			headers: { Accept: "application/json", "Content-Type": "application/json" },
			method: "POST",
			mode: "cors",
			cache: "default",
			body: vDATAS,
		}).then((response)=> { if (response.status === 200) { setSessionaktif(false); return response.json(); } })
		.then((output_string) => {
			setSessionaktif(true)
			vElsimpan && (vElsimpan.disabled = false);
			setLoading(false);
			//console.log("(Lapkasir-apiLoadview) output_string : "+JSON.stringify(output_string.errors));
			if(output_string.tampil) {
				const vTmpArr = (JSON.parse(output_string.datalaporan || "[]"));
				setDatavieworiArr([{firstrow:1},...vTmpArr]);

				const vTimeEnd = new Date();
				const vTimeDiff = vTimeEnd - vTimeBegin; //in ms
				setTimeElapsed(vTimeDiff);

				setDataloadedObj(uDlgformObj);
				setDlgformshow(false);
			} else if(output_string.info) {
				showToast(output_string.info);
			} else if(output_string.errors) {
				console.log("(Lapkasir-apiLoadview) output_string.errors : "+output_string.errors);
				const vMsg 	= (pjson.mydefault.environment==="development")
					? output_string.errors : pjson.mydefault.msgFetchError;
				showToast(vMsg,"ERROR");
			} else if(output_string.expired) {
				setLoading(true); prosesExpired();
			}
		})
		.catch((error) =>{
			vElsimpan && (vElsimpan.disabled = false);
			setLoading(false);
			console.log("(Lapkasir - apiLoadview) catch-error: "+error);
			showToast(pjson.mydefault.msg500str.join(" "),"ERROR");
		});
	}
	/*const apiLoaditem = (_IDTABEL) => {//--TIDAK_DIPAKAI--/
		_IDTABEL = parseInt(_IDTABEL)||0; if(_IDTABEL <= 0) return;
		const vArridx	= UFunc.getObjectIndeks(uDataviewArr,_IDTABEL);
		uDataviewArr[vArridx].is_processing = true;
		setEfekview(!uEfekview);

		const vDATAS	= JSON.stringify({
			send_tabelid: _IDTABEL,
			send_tokenauth : uTokenObj.userinit
		});
		const vURLs	= pjson.homepage+"api/api_lapkasir/ld_item";

		setTimeElapsed(0);
		const vTimeBegin = new Date();
		fetch(vURLs,{
			headers: { Accept: "application/json", "Content-Type": "application/json" },
			method: "POST",
			mode: "cors",
			cache: "default",
			body: vDATAS,
		}).then((response)=> { if (response.status === 200) { setSessionaktif(false); return response.json(); } })
		.then((output_string) => {
			setSessionaktif(true)
			uDataviewArr[vArridx].is_processing = false;
			//console.log("(Lapkasir-apiLoaditem) output_string : "+JSON.stringify(output_string.errors));
			if(output_string.tampil) {
				const vDetildataArr 			= JSON.parse(output_string.dataitem || "[]");
				uDataviewArr[vArridx].item_arr 	= vDetildataArr;

				uDlgviewObj.header = "Detil Item: "+uDataviewArr[vArridx].no_nota;
				setDlgviewshow(true);
			} else if(output_string.info) {
				showToast(output_string.info);
			} else if(output_string.errors) {
				console.log("(Lapkasir-apiLoaditem) output_string.errors : "+output_string.errors);
				const vMsg 	= (pjson.mydefault.environment==="development")
					? output_string.errors : pjson.mydefault.msgFetchError;
				showToast(vMsg,"ERROR");
			} else if(output_string.expired) {
				setLoading(true); prosesExpired();
			}
		})
		.catch((error) =>{
			uDataviewArr[vArridx].is_processing = false;
			console.log("(Lapkasir - apiLoaditem) catch-error: "+error);
			showToast(pjson.mydefault.msg500str.join(" "),"ERROR");
		});
	}//-*/
	//---END API--/

	React.useEffect(()=>{
		uDispatch({type: "set", effectApp: !uEfekapp});
		uDispatch({type: "set", gUrlbefore: window.location.pathname + window.location.search});

		apiLoadinit();

		return () => {
			uDispatch({type: "set", gInitHeaderAction: {}});
			setDlgformshow(false);
			//setDlglookupshow(false); setDlgviewshow(false);

			setDataloadedObj();
			setTitelObj();
			setDataviewArr([]);
			setDatavieworiArr([]);
			setDatapaymentArr([]);
			setDataidentitasObj({});
			setJmlData(0);setJmlHal(0);
		}
	},[])
	React.useEffect(()=>{ 
		setTabelIDPilih(0);
		setTabelRowSelect(-1); 
	},[uPageActive]);
	React.useEffect(()=>{
		const vDatadefaultArr = uDatavieworiArr.slice(1);
		setDataviewArr(vDatadefaultArr);
	},[uDatavieworiArr,uDatavieworiArr.length])
	React.useEffect(()=>{
		setJmlData(uDataviewArr.length);

		const vSumnilai = uDataviewArr.reduce((vNilaistored,vItems)=>{
			return (parseFloat(vNilaistored)||0) + (parseFloat(vItems.nilai_mutasi)||0)
		}, 0);

		uDataloadedObj && (setDataloadedObj({...uDataloadedObj,
			sum_nilai_mutasi: vSumnilai,
		}));
	},[uDataviewArr,uDataviewArr.length])
	React.useEffect(()=>{
		let vJmlHal	= Math.ceil(uJmlData / uMaxData);
		setJmlHal(vJmlHal);//-*/

		if(!uElJmldata) return;
		initJmldata();
	},[uElJmldata,uJmlData]);
	React.useEffect(()=>{
		if(!uHandelView) return;

		uHeaderActionObj.isHeaderView = false;
		uDispatch({type: "set", gInitHeaderAction: uHeaderActionObj});

		if(uHTMLError500) return;

		const vTanggalnowDT	= new Date();
		if(uDlgformObj.jenis === undefined)
			uDlgformObj.jenis = uDataloadedObj ? uDataloadedObj.jenis : "HARIAN";
		if(uDlgformObj.bln_id === undefined)
			uDlgformObj.bln_id = uDataloadedObj ? uDataloadedObj.bln_id : vTanggalnowDT.getMonth()+1;
		if(uDlgformObj.tahun === undefined)
			uDlgformObj.tahun = uDataloadedObj ? uDataloadedObj.tahun : vTanggalnowDT.getFullYear();
		if(uDlgformObj.tanggal === undefined)
			uDlgformObj.tanggal = uDataloadedObj ? uDataloadedObj.tanggal : UFunc.DbDate(vTanggalnowDT);
		if(uDlgformObj.payment_id === undefined)
			uDlgformObj.payment_id = uDataloadedObj ? uDataloadedObj.payment_id : 0;
		
		uDlgformObj.header = "Pilih Filter Laporan";
		setDlgformshow(true);
	},[uHandelView]);
	React.useEffect(()=>{
		if(!uHandelReset) return;

		uHeaderActionObj.isHeaderReset = false;
		uDispatch({type: "set", gInitHeaderAction: uHeaderActionObj});

		if(uHTMLError500 || !uDataloadedObj) apiLoadinit()
		else { setDatavieworiArr([]);setDataviewArr([]); setDataloadedObj(); }
	},[uHandelReset]);
	React.useEffect(()=>{
		const vElfilter	= document.getElementById("btnFilter");
		if(!uISDlgformshow) { 
			vElfilter && (vElfilter.disabled = false)
			setDlgformObj({}); return 
		}

		vElfilter && (vElfilter.disabled = true)
		let vTimeout = setTimeout(()=>{
			clearTimeout(vTimeout);

			if(isMobile) return;

			const vElfocus = document.getElementById("inpjenis");
			if(!isMobile) vElfocus && vElfocus.focus();
		},350);
	},[uISDlgformshow]);
	React.useEffect(()=>{
		if(uDlgformObj.jenis === undefined) return;

		let vEltarget = document.getElementById("inppaymentid");
		if(uDlgformObj.jenis === "REKAPHARIAN") {
			uDlgformObj.payment_id = 0;

			if(!vEltarget) {
				let vTimeout = setTimeout(()=>{
					clearTimeout(vTimeout);

					vEltarget = document.getElementById("inppaymentid");
					vEltarget && (vEltarget.disabled = true);
				},350); return; 
			}

			vEltarget && (vEltarget.disabled = true);
			return;
		}

		vEltarget && (vEltarget.disabled = false);
	},[uDlgformObj,uDlgformObj.jenis]);
	/*React.useEffect(()=>{//--TIDAK_DIPAKAI--/
		if(!uISDlglookupshow)
			{ setDlglookupObj({}); return }
	},[uISDlglookupshow]);//-*/
	React.useEffect(()=>{
		if(!uDataloadedObj) { setTitelObj({}); return }

		(uTitelObj||{}).periode 	= (uDataloadedObj.jenis === "BULANAN") ? 
			cBulanPanjang[parseInt(uDataloadedObj.bln_id)-1]+" "+uDataloadedObj.tahun : 
			(uDataloadedObj.jenis === "HARIAN" ? "TGL ":"REKAP TGL ")+UFunc.TglAngka(uDataloadedObj.tanggal);

		if((parseInt(uDataloadedObj.payment_id)||0) < 0)  (uTitelObj||{}).subtitel = "SEMUA METODE";
		else {
			const vArridx = UFunc.getObjectIndeks(uDatapaymentArr,uDataloadedObj.payment_id);
			(uTitelObj||{}).subtitel = vArridx >= 0 
				? "Metode: "+(uDatapaymentArr[vArridx].caption||"") : "SEMUA METODE PEMBAYARAN";
		}
	},[uDataloadedObj]);
	React.useEffect(()=>{
		if(uDatavieworiArr.length <= 0) return;

		if(uPageActive > 1) setPageActive(1);
		else { setTabelRowSelect(-1); setTabelIDPilih(0); }

		if(UFunc.isEmpty(uSortedObj)) { 
			const vDatadefaultArr = uDatavieworiArr.slice(1);
			setDataviewArr(vDatadefaultArr);
			return
		}

		if(uSortedObj.mode==="ASC") {
			uDataviewArr.sort((a,b)=> a[uSortedObj.field] - b[uSortedObj.field])
		} else if(uSortedObj.mode==="DESC") {
			uDataviewArr.sort((a,b)=> b[uSortedObj.field] - a[uSortedObj.field])
		}
	},[uSortedObj,
	uSortedObj.field,
	uSortedObj.mode
	]);
	
	//console.log("Lapkasir - uActiveroute => "+(uActiveroute));

	if(UFunc.isEmpty(uTokenObj)) { setLoading(true); prosesExpired(); return; }
	if(uHTMLError500) return ( <MyPage500 content={uHTMLError500}/> )//>

	return (
	<>
		{(!uDataloadedObj) ? (
		<CCard className="classcardbg">
			<CCardHeader className="">
			<small className="fw-bolder">Pilih Filter Laporan</small>
			</CCardHeader>

			<CCardBody className="d-flex justify-content-center align-items-center" style={{minHeight:200}}>
			<div className="classpetunjuk">
			*) Silahkan Pilih Filter, untuk menentukan Parameter Laporan yang akan Ditampilkan. Kemudian Tekan SIMPAN. Untuk Mencetak Silahkan KLIK Ikon Cetak..
			</div>
			</CCardBody>
		</CCard>
		) : (
		<CCard className="classcardbg">
			<CCardHeader className="d-flex justify-content-between">
			<div>
			
			{(uTitelObj||{}).periode && (
			<div className="">Periode <b>{uTitelObj.periode}</b></div>
			)}

			{(uTitelObj||{}).subtitel && (
			<small className="text-primary">{uTitelObj.subtitel}</small>
			)}
			</div>

			<div>
				<CLink onClick={()=>hdlKlikCetak()} className="classcursorpointer classikon classikoncetak"/>
				<span className="mx-1">&middot;</span>
				<CLink onClick={()=>hdlKlikExcel()} className="classcursorpointer classikon classikonexcel"/>
				<span className="mx-1">&middot;</span>
				<span className="classfontsmaller">
					<small className="text-muted">
						{UFunc.formatAngka(uTimeElapsed)}ms
					</small>
				</span>
			</div>
			</CCardHeader>

			<CCardBody className="px-0">{contentMain()}</CCardBody>

			{((uJmlData > uMaxData)) && (
			<CCardFooter>
				<MyPagination
					activePage={uPageActive}
					pages={uJmlHal}
					onActivePageChange={(i) => setPageActive(i)}/>
			</CCardFooter>
			)}
		</CCard>
		)}

		<MyDialogform
			options={{centered:true}}
			onSimpan={hdlKlikDlgformsimpan}
			show={uISDlgformshow} 
			dialogHeader={uDlgformObj.header}
			toggle={()=>setDlgformshow(false)}
			renderContent={contentDlgform()}/>

		<iframe id="ifmcontentstoprint" title="FrameCetak" className="d-none"/>
	</>
	)//>
}	

export default Lapkasir